import Home from "./pages/Home/Home";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  return (
    <ThemeProvider>
    <div className="App">
      <Home />
    </div>
    </ThemeProvider>
  );
}

export default App;
